<div [ngClass]="{
    'ui-rtl': cls.currentDirection() === 'rtl',
    'ui-ltr': cls.currentDirection() === 'ltr',
  }" [dir]="cls.currentDirection()">
  <router-outlet />

  <p-confirmDialog>
    <ng-template #message let-message>
      <div class="w-96 flex gap-3 flex-row items-center">
        <span style="color: var(--p-red-500)">
          <i [class]="message.icon"></i>
        </span>
        <span class="text-2xl">
          {{ message.message }}
        </span>
      </div>
    </ng-template>
  </p-confirmDialog>
  <p-toast />
  <p-toast key="app-update" position="bottom-right" styleClass="app-update-toast">
    <ng-template #message let-message>
      <div class="flex flex-col gap-3">
        <div class="flex items-start gap-3">
          <span class="app-update-toast__icon flex items-center justify-center flex-shrink-0">
            <i class="pi pi-refresh"></i>
          </span>
          <div class="flex flex-col gap-1" style="min-width: 0">
            <span class="font-semibold">{{ message.summary }}</span>
            <span class="text-sm app-update-toast__detail">{{ message.detail }}</span>
          </div>
        </div>
        <button
          pButton
          type="button"
          class="p-button-sm w-full justify-center"
          icon="pi pi-refresh"
          [label]="'Reload' | translate"
          (click)="versionCheck.reload()"
        ></button>
      </div>
    </ng-template>
  </p-toast>
  <p-dialog [modal]="true" [(visible)]="stateService.personlaInfoCard" [style]="{ width: '40rem' }" closeOnEscape="true"
    [dir]="!cls.currentDirection()">
    <ng-template #header>
      <div class="inline-flex items-center justify-center gap-2"></div>
    </ng-template>
  </p-dialog>
</div>